/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ListOtherEmployersForCompanyEmployer interface.
 */
export function instanceOfListOtherEmployersForCompanyEmployer(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
export function ListOtherEmployersForCompanyEmployerFromJSON(json) {
    return ListOtherEmployersForCompanyEmployerFromJSONTyped(json, false);
}
export function ListOtherEmployersForCompanyEmployerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'inviteId': json['inviteId'] == null ? undefined : json['inviteId'],
        'name': json['name'],
        'email': json['email'],
    };
}
export function ListOtherEmployersForCompanyEmployerToJSON(json) {
    return ListOtherEmployersForCompanyEmployerToJSONTyped(json, false);
}
export function ListOtherEmployersForCompanyEmployerToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'inviteId': value['inviteId'],
        'name': value['name'],
        'email': value['email'],
    };
}
